import React, { useEffect, useMemo } from 'react';
import AdvancedRecordTable from '../../../components/Tables/advancedRecord/AdvancedRecordTable';
import { correlativesAdminColumns } from '../../../features/settings/correlatives/correlativesAdminColumns';
import { useCorrelativesAdmin } from '../../../hooks/settings/useCorrelativesAdmin';
import CorrelativeResetModal from './CorrelativeResetModal';

const CorrelativesAdminTableSection: React.FC = () => {
  const {
    list,
    handlerLoadSequences,
    handlerOpenDetailModal,
    handlerResetAllSequences,
  } = useCorrelativesAdmin();

  useEffect(() => {
    handlerLoadSequences();
  }, []);

  const columns = useMemo(() => correlativesAdminColumns, []);

  const getActions = (row: any) => [
    {
      label: 'Ver / Reset',
      key: 'view',
      onClick: () => handlerOpenDetailModal(row.id),
    },
  ];

  return (
    <>
      <AdvancedRecordTable
        columns={columns}
        data={list}
        getActions={getActions}

        /* 🔧 Props requeridos por AdvancedRecordTable */
        paginator={undefined}
        pageSize={10}
        onPageChange={() => {}}
        onPageSizeChange={() => {}}

        noDataMessage="No hay secuencias de correlativos registradas."

        /* 🔥 BOTÓN GLOBAL (NO SE QUITA) */
        topRightAction={{
          label: 'Restablecer todos',
          onClick: handlerResetAllSequences,
        }}
      />

      {/* 🧩 Modal desacoplado */}
      <CorrelativeResetModal />
    </>
  );
};

export default CorrelativesAdminTableSection;
